import { SurveyModel } from "./survey.model";

export class SurveyListModel extends SurveyModel {
    public numOfLinks!: number;
    public status!: string;
    public totalSubmissions!: number;
    public createdOn!: Date;
    public totalRecords: number = 0;
}

export class SurveyLinkModel extends SurveyListModel {
    public linkList: LinkModel[] = [];
}

export class LinkModel {

    public id: number = 0;
    public status: string = '';
    public link: string = '';
    public isPublic: boolean = false;
    public createdOn: Date = new Date();
}